import { PlatformLocation } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { shareReplay } from 'rxjs/operators'

/**
 * @description
 * @class
 */
@Injectable()
export class AppInitService {
  public Envronment$: Observable<any>

  constructor(
    public platformLocation: PlatformLocation,
    private http: HttpClient
  ) {
    // Use platformLocation.search or window.location.search as fallback
    const queryString =
      this.platformLocation?.search || window.location.search || ''
    const urlParams = new URLSearchParams(queryString)
    const token = urlParams.get('token')
    if (token !== null) {
      sessionStorage.removeItem('api_token')
      sessionStorage.setItem('api_token', token)
    }
  }

  URLS = {
    DEV: 'https://dev-deductionslink.inmar.com',
    BETA: 'https://beta-deductionslink.inmar.com',
    LOCALHOST: 'http://localhost:4200',
    TEST_UI:
      'https://fintech-dmp-test-ui-service-822157821.us-central1.run.app',
    TEST_API:
      'https://fintech-dmp-test-api-service-822157821.us-central1.run.app',
    UAT: 'https://uat-deductionslink.inmar.com',
    PROD: 'https://deductionslink.inmar.com',
  }

  SUB_DOMAIN = {
    DEV: 'uat',
    QA: 'uat',
    UAT: 'uat',
    PROD: 'prod',
  }

  ENVIRONMENT = {
    DEV: 'dev',
    QA: 'qa',
    UAT: 'uat',
    PROD: 'prod',
  }

  public loadEnvronments(): any {
    // Use platformLocation methods or window.location as fallback
    const currentURL = this.platformLocation?.protocol
      ? `${this.platformLocation.protocol}//${this.platformLocation.hostname}${this.platformLocation.port ? ':' + this.platformLocation.port : ''}`
      : window.location.origin
    let subDomain
    let env
    if (currentURL === this.URLS.DEV) {
      subDomain = this.SUB_DOMAIN.DEV
      env = this.ENVIRONMENT.DEV
    } else if (
      currentURL === this.URLS.BETA ||
      currentURL === this.URLS.LOCALHOST ||
      currentURL === this.URLS.TEST_UI
    ) {
      subDomain = this.SUB_DOMAIN.UAT
      env = this.ENVIRONMENT.QA
    } else if (currentURL === this.URLS.UAT) {
      subDomain = this.SUB_DOMAIN.UAT
      env = this.ENVIRONMENT.UAT
    } else if (currentURL === this.URLS.PROD) {
      subDomain = this.SUB_DOMAIN.PROD
      env = this.ENVIRONMENT.PROD
    }

    if (!this.Envronment$) {
      const url =
        'https://us-central1-inm-deductionmgtportal-' +
        subDomain +
        '.cloudfunctions.net/fr_config?e=' +
        env
      this.Envronment$ = this.http.get(url).pipe(shareReplay(1))
    }
    return this.Envronment$
  }
}
